import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: auto;
  font-family: "Segoe UI", sans-serif;
`;

export const FilterBox = styled.form`
  background: #f9f9f9;
  padding: 20px;
  margin-bottom: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: flex-end;
`;

export const Label = styled.label`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 180px;
  font-size: 14px;
`;

export const Select = styled.select`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 250px;
  font-size: 14px;
`;

export const Button = styled.button`
  padding: 10px 16px;
  background-color: ${(props) => (props.$secondary ? "#e0e0e0" : "#007bff")};
  color: ${(props) => (props.$secondary ? "#333" : "#fff")};
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.$secondary ? "#d0d0d0" : "#0056b3")};
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);

  th, td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid #eee;
     max-width: 300px;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  th {
    background-color: #f1f5f9;
    font-size: 14px;
    font-weight: 600;
  }

  tbody tr:nth-child(even) {
    background-color: #f9fafb;
  }

  tbody tr:hover {
    background-color: #eef6ff;
  }
`;

export const Message = styled.p`
  text-align: center;
  font-size: 16px;
  margin-top: 30px;
  color: #666;
`;


export const DeleteButton = styled.button`
  padding: 6px 12px;
  background-color: #ff4d4f;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #d9363e;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.4);
  }
`;
